
export class SearchStudent {
    studentDetailItem: StudentDetails;
    studentAdditionalDetailsItem: StudentAdditionalDetails;
    studentPupilDetailsItem: StudentPupilDetails;
    studentId: number;
    /** The learner's brand. */
    companyId?: number;
    /**
     * The distinct key stages of the learner's bookings (e.g. ['KS3']). Returned only when the search
     * sent `keyStages` (the filters.learner-search switch is on); absent otherwise.
     */
    keyStages?: string[];
  }

export class StudentDetails {
    companyId: number;
    firstName: string;
    surname: string;
    gender?: number;
    dateOfBirth?: string;
    age?: number;
    studentStatus?: number;
    createdUserId: string;
    createdOn: Date;
    updatedUserId: string;
    updatedOn?: Date;
    emailAddress?: string;
    hiddenFromAllocation: boolean;
    studentQuickLabel: string;
}

export class StudentAdditionalDetails {
    learnerBackground: string;
    behaviourBackground: string;
    studentNotes: string;
    healthAndSafety: string;
    updatedUserId: string;
    updatedOn: Date;
}

export class StudentPupilDetails {
    clientId?: number;
    clientName: string;
    mainSubject: string;
    upn: string;
    yearGroup: string;
    eligableForPupilPremium?: boolean;
    sendPupil?: boolean;
    cin?: boolean;
    lac?: boolean;
    pupilDataSharingWithdrawn?: boolean;
    pupilRemoved?: boolean;
    pupilRemovedDate?: Date;
    withdrawnDate?: Date;
    withDrawnByParent?: boolean;
}
